/*
  {% render 'product-quantity-selector', product: product %}
*/

const syncQtyInputWidth = (input) => {
  const chars = Math.max(1, String(input.value || '1').length);
  input.style.width = `${chars}ch`;
};

const initQuantityInputs = (container = document.querySelector('[data-product-main]')) => {
  if (!container) return;
  const quantitySelectors = container.querySelectorAll('[data-quantity-selector]');

  if (!quantitySelectors.length) return;

  const changeInput = (qtyInput, value, selector) => {
    const maxQty = +selector.getAttribute('data-max-quantity');
    if (maxQty && +qtyInput.value >= maxQty && value > 0) return;
    if (qtyInput.checkValidity()) {
      const inputValue = +qtyInput.value;
      const newValue = inputValue + value;
      qtyInput.value = String(newValue);
      syncQtyInputWidth(qtyInput);
    }
  };

  quantitySelectors.forEach(selector => {
    const qtyInput = selector.querySelector('[data-quantity-input]');
    if (!qtyInput) return;

    syncQtyInputWidth(qtyInput);
    qtyInput.addEventListener('input', () => syncQtyInputWidth(qtyInput));
    qtyInput.addEventListener('change', () => changeInput(qtyInput, 0, selector));
    selector.addEventListener('click', (evt) => {
      const decBtn = evt.target.closest('[data-quantity-dec]');
      const incBtn = evt.target.closest('[data-quantity-inc]');
      decBtn && +qtyInput.value > 1 ? changeInput(qtyInput, -1, selector) : null;
      incBtn ? changeInput(qtyInput, +1, selector) : null;
    });
  });
};

export default initQuantityInputs;
